import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { LnBreadcrumb } from "../components/LnBreadcrumb";
import { LnExplainer } from "../components/LnExplainer";
import { LoanTool } from "../components/LoanTool";

export function LoanCalculatorPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <LnBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.ln_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.ln_intro()}
          </p>
        </header>

        <LoanTool />

        <LnExplainer
          howTo={m.ln_howto()}
          faqs={[
            { q: m.ln_faq1_q(), a: m.ln_faq1_a() },
            { q: m.ln_faq2_q(), a: m.ln_faq2_a() },
            { q: m.ln_faq3_q(), a: m.ln_faq3_a() },
            { q: m.ln_faq4_q(), a: m.ln_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
